export interface IAddressModel {
  uuid?: string;
  street: string;
  number: number;
  district: string;
  zipCode: string;
  city: string;
  state: string;
  country?: string;
  complement: string;
  fullName: string;
}

export class AddressModel implements IAddressModel {
  uuid?: string;
  key?: React.Key;
  street: string;
  number: number;
  district: string;
  zipCode: string;
  city: string;
  state: string;
  country?: string;
  complement: string;
  fullName: string;

  constructor(data: IAddressModel) {
    this.uuid = data.uuid;
    this.key = data.uuid;
    this.street = data.street;
    this.number = data.number;
    this.district = data.district;

    this.zipCode = data.zipCode?.replace("-", "");

    this.city = data.city;
    this.state = data.state;
    this.country = data.country ?? "Brazil";
    this.complement = data.complement;
    this.fullName = data.fullName;
  }
}